import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { apiFetch, ApiError } from "@/lib/api";
import { saveTokens } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function MfaChallengePage() {
  const [params] = useSearchParams();
  const challenge = params.get("challenge") ?? "";
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault(); setError(null);
    try {
      const res = await apiFetch<{ accessToken: string; accessTokenExpiresUtc: string; refreshToken: string; refreshTokenExpiresUtc: string }>(
        "/api/auth/mfa", { method: "POST", body: JSON.stringify({ mfaChallengeToken: challenge, code }) });
      saveTokens({ accessToken: res.accessToken, accessExpiresUtc: res.accessTokenExpiresUtc, refreshToken: res.refreshToken, refreshExpiresUtc: res.refreshTokenExpiresUtc });
      void nav("/");
    } catch (e) { setError(e instanceof ApiError ? e.message : "Code rejected"); }
  }

  return (
    <div className="mx-auto mt-24 max-w-sm space-y-4">
      <h1 className="text-2xl font-semibold">Two-factor verification</h1>
      <form onSubmit={(e) => void submit(e)} className="space-y-3" noValidate>
        <div><Label htmlFor="code">Authenticator code</Label><Input id="code" inputMode="numeric" value={code} onChange={(e) => setCode(e.target.value)} required /></div>
        {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
        <Button type="submit">Verify</Button>
      </form>
    </div>
  );
}
